import React from 'react'
import { Checkbox, Modal } from 'antd'

import { InlineSelect } from '../../../components/scharedStyles/style'
import { ExportButton, ExportNotice, ModalHint } from './style'
import { useScheduleExport } from './useScheduleExport'

const ScheduleExport = () => {
    const {
        exportNotice,
        isExporting,
        exportModalOpen,
        selectedExportGroupId,
        saveOnServer,
        groupOptions,
        openModal,
        closeModal,
        exportSchedule,
        selectExportGroup,
        setSaveOnServer,
    } = useScheduleExport()

    return (
        <>
            <ExportButton type="button" onClick={openModal}>
                Экспортировать
            </ExportButton>

            {exportNotice && <ExportNotice>{exportNotice}</ExportNotice>}

            <Modal
                title="Экспорт расписания"
                open={exportModalOpen}
                onCancel={closeModal}
                onOk={exportSchedule}
                confirmLoading={isExporting}
            >
                <ModalHint>Выберите группу для экспорта:</ModalHint>
                <InlineSelect
                    showSearch
                    allowClear
                    value={selectedExportGroupId || undefined}
                    onChange={selectExportGroup}
                    options={groupOptions}
                    placeholder="Выбрать группу"
                />
                <Checkbox checked={saveOnServer} onChange={(e) => setSaveOnServer(e.target.checked)}>
                    Сохранить на сервере
                </Checkbox>
            </Modal>
        </>
    )
}

export default ScheduleExport
